import { memo, useMemo, useEffect, useState } from 'react';

import Image from 'next/image';

import { getHotRecommend } from '@/apis/list';
import Nav from '@/components/Nav';

const Index = (props) => {
  const { resourceData, icDetail, icRecommend } = props;
  const [hotRecommendList, setHotRecommendList] = useState([]);

  const navList = useMemo(() => {
    return [
      {
        name: '元器件商城',
        url: resourceData?.projectConfigVO.lcscWwwUrl,
      },
      { name: icDetail?.icModel },
    ];
  }, [icDetail?.icModel]);

  useEffect(() => {
    getHotRecommendFun();
  }, []);

  const getHotRecommendFun = async () => {
    const res = await getHotRecommend();
    if (res?.code === 200) {
      setHotRecommendList(res?.result || []);
    }
  };

  return (
    <div className={'w-[1200px] m-auto pt-[18px] pb-[51px]'}>
      <Nav navList={navList} showLastArrow={false}></Nav>

      <div className={'flex mt-[15px] mb-[20px]'}>
        <div className={'w-[810px] mr-[20px]'}>
          <section className={'mb-[20px] bg-white  rounded-[20px] flex p-[20px]'}>
            <div
              className={
                'flex justify-center items-center w-[260px] h-[260px] border border-solid border-[#ECECEC] rounded-[6px]  mr-[30px]'
              }
            >
              <div className={'w-[260px] h-[130px] relative'}>
                <Image
                  src={`${resourceData?.projectConfigVO?.lcscAttaUrl}${icDetail?.productImgUrl}`}
                  alt={icDetail?.icModel}
                  fill
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </div>
            <div className={'flex-1  text-[14px]'}>
              <h1 className={'mb-[19px] text-[#0B1832] text-[20px] font-bold leading-[27px]'}>{icDetail?.icModel}</h1>
              <ul>
                <li className={'mb-[16px] flex'}>
                  <b className={'block text-[#69788A] leading-[19px] mr-[30px] w-[58px]'}>厂商名称</b>
                  <span className={'flex-1 text-[#000000]  leading-[19px]'}>{icDetail?.factoryModel}</span>
                </li>
                <li className={'mb-[16px] flex'}>
                  <b className={'block text-[#69788A] leading-[19px] mr-[30px] w-[58px]'}>元件分类</b>
                  <span className={'flex-1 text-[#000000]  leading-[19px]'}>{icDetail?.componentType}</span>
                </li>
                <li className={'mb-[16px] flex'}>
                  <b className={'block text-[#69788A] leading-[19px] mr-[30px] w-[58px]'}>中文描述</b>
                  <span className={'flex-1 text-[#000000]  leading-[19px]'}>{icDetail?.remarkCn}</span>
                </li>
                <li className={'mb-[16px] flex'}>
                  <b className={'block text-[#69788A] leading-[19px] mr-[30px] w-[58px]'}>英文描述</b>
                  <span className={'flex-1 text-[#000000]  leading-[19px]'}>{icDetail?.remarkEn}</span>
                </li>
                <li className={'mb-[16px] flex'}>
                  <b className={'block text-[#69788A] leading-[19px] mr-[30px] w-[58px]'}>数据手册</b>
                  <span className={'flex-1 text-[#000000]  leading-[19px]'}>
                    {icDetail?.icModel + '数据手册Datasheet PDF'}
                  </span>
                </li>
                <li className={'flex items-center'}>
                  <a
                    href={`${resourceData?.projectConfigVO.lcscSearchUrl}/global.html?k=${icDetail?.icModel}&c=SS`}
                    target={'_blank'}
                    className={
                      'bg-[#FF4960] h-[32px] leading-[32px] rounded-[6px] text-center text-white w-[88px] hover:text-[#FFFFFF] hover:opacity-80'
                    }
                  >
                    在线购买
                  </a>
                </li>
              </ul>
            </div>
          </section>
          <section className={'mb-[20px] bg-white rounded-[20px] flex flex-col p-[20px]'}>
            <h2 className={'mb-[20px] text-[#0B1832] text-[18px] font-bold leading-[24px]'}>
              {icDetail?.icModel + '概述'}
            </h2>
            <div
              className={'text-[#0B1832] leading-[19px]'}
              dangerouslySetInnerHTML={{
                __html: icDetail?.sketchOut,
              }}
            />
          </section>
          <section className={'mb-[20px] bg-white rounded-[20px] flex flex-col py-[20px]'}>
            <h2 className={'px-[20px] text-[#0B1832] text-[18px] font-bold leading-[24px]'}>
              {icDetail?.icModel + '中文参数'}
            </h2>
            <div
              id="productIntro"
              dangerouslySetInnerHTML={{
                __html: icDetail?.paramCn,
              }}
            />
          </section>
          <section className={'bg-white rounded-[20px] flex flex-col p-[20px]'}>
            <h2 className={'mb-[20px] text-[#0B1832] text-[18px] font-bold leading-[24px]'}>
              {icDetail?.icModel + '引脚图'}
            </h2>
            <div className={'w-[771px] h-[214px] relative'}>
              <Image
                src={`${resourceData?.projectConfigVO?.lcscAttaUrl}${icDetail?.circuitDiagramUrl}`}
                alt={icDetail?.icModel + '引脚图和PCB焊盘图'}
                fill
                style={{ objectFit: 'contain' }}
              />
            </div>
          </section>
        </div>
        <section className={'w-[370px] '}>
          <div className={'rounded-[20px] bg-white p-[20px]'}>
            <h2 className={'mb-[8px] text-[#020202] text-[14px] font-bold leading-[24px]'}>爆款物料推荐</h2>
            <div className={'bg-[#FAFAFA] rounded-[10px]'}>
              <div
                className={
                  'flex w-[330px] text-[14px]  px-[16px] h-[33px] bg-[#F1F1F1] rounded-tl-[10px] rounded-tr-[10px] text-[#69788A] leading-[19px] items-center'
                }
              >
                <div className={'w-[203px]'}>型号</div>
                <div className={'flex-1'}>价格</div>
              </div>
              <ul className={'mt-[6px] pb-[9px] px-[16px]'}>
                {hotRecommendList.map((item) => {
                  return (
                    <li
                      key={item?.productId}
                      className={'flex w-[330px] text-[14px] h-[24px] text-[#000000] leading-[24px] mb-[6px]'}
                    >
                      <a
                        className={'w-[203px] truncate hover:text-[#0093E6]'}
                        href={`${resourceData?.projectConfigVO.lcscItemUrl}/${item?.productId}.html`}
                        target="_blank"
                        title={item?.productModel}
                      >
                        {item?.productModel}
                      </a>
                      <div className={'flex-1'}>{item?.productLadderPrice}</div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </section>
      </div>

      <section className={'mb-[20px] bg-white rounded-[20px] flex flex-col p-[20px] pb-[0px]  mr-[20px]'}>
        <strong className={'mb-[20px] text-[#0B1832] text-[18px] font-bold leading-[24px]'}>热门物料推荐</strong>
        <ul className={'grid grid-cols-5 gap-x-4'}>
          {(icRecommend?.dataList || []).map((item) => {
            return (
              <li
                key={item?.icModel}
                className={'mb-[20px] text-[#000000] text-[12px] leading-[16px] h-[18px] truncate'}
                title={item?.icModel}
              >
                <a
                  href={`${resourceData?.projectConfigVO.lcscWwwUrl}/p/${item?.icModel}_${item?.icDataId}.html`}
                  className={'hover:!text-[#0093E6]'}
                >
                  {item?.icModel}
                </a>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
};

export default memo(Index);
